module.exports = __webpack_public_path__ + "img/02.171a8448.jpg";